import React from 'react'
import PropTypes from 'prop-types'

import {
    ContainerList,
} from './styles'
import CardTabela from "../CardTabela";

export default function ListaCardsTabela(props) {
    let n_buttons = 0
    const listaDeCards = props.listaDeCards
    for(let i=0; i<listaDeCards.length; i++){
        if(listaDeCards[i].botaoExtra){
            n_buttons = 2
            break
        }
        else if(listaDeCards[i].botao && n_buttons <2){
            n_buttons = 1
        }
    }
    return (
        <ContainerList maxOffer={props.listaDeCards.length > 2}>
            {props.listaDeCards.map((item, index) => <CardTabela card={item} key={index} n_buttons={n_buttons}/>)}
        </ContainerList>
    )  
}

ListaCardsTabela.propTypes = {
    listaDeCards: PropTypes.array
}
